import React from "react";

import { ReactComponent as ShareIcon } from "./assets/share.svg";
import { ShareTrackBtn } from "./styled";

/**
 * @example
 * <ShareButton shareData={{
 *   title: "Пример",
 *   text: "Поделиться этим контентом",
 *   url: "https://example.com"
 * }} />
 */

export const ShareButton = ({ shareData }) => {
  if (!navigator.canShare?.(shareData)) {
    return null;
  }

  const handleClickShareBtn = async () => {
    await navigator.share(shareData);
  };

  return (
    <ShareTrackBtn onClick={handleClickShareBtn} withBgColor>
      <ShareIcon />
    </ShareTrackBtn>
  );
};
